import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ products: 0, orders: 0, pending: 0, revenue: 0 });
    useEffect(() => {
        (async () => {
            const [p, o] = await Promise.all([api.get("/admin/products"), api.get("/admin/orders")]);
            const revenue = o.data.filter(x => x.status !== "cancelled").reduce((s, x) => s + (x.total || 0), 0);
            const pending = o.data.filter(x => ["pending", "processing"].includes(x.status)).length;
            setStats({ products: p.data.length, orders: o.data.length, pending, revenue });
        })();
    }, []);
    return (
        <div data-testid="admin-dashboard">
            <h1 className="font-display text-4xl tracking-tighter mb-6">Dashboard</h1>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                    ["Products", stats.products],
                    ["Orders", stats.orders],
                    ["Pending", stats.pending],
                    ["Revenue (INR)", `₹${Math.round(stats.revenue)}`],
                ].map(([l, v]) => (
                    <div key={l} className="bg-white border-2 border-black p-6 brutal-shadow">
                        <div className="font-mono text-[10px] uppercase text-neutral-500">{l}</div>
                        <div className="font-display text-4xl mt-2">{v}</div>
                    </div>
                ))}
            </div>
            <div className="mt-8 bg-white border-2 border-black p-6">
                <div className="font-mono text-xs uppercase mb-2">Quick Setup Checklist</div>
                <ul className="text-sm space-y-1">
                    <li>✔ Admin account seeded</li>
                    <li>✔ Razorpay <b>LIVE</b> keys configured — real payments enabled</li>
                    <li>✔ Qikink Sandbox connected — auth & order-push endpoint verified</li>
                    <li>✔ Resend email configured with verified domain (orders@clonzo.in)</li>
                    <li>◻ In your Qikink dashboard, create products whose <b>SKUs match</b> the SKUs you enter here so paid orders auto-fulfill</li>
                    <li>◻ Add <code className="font-mono">GA4_MEASUREMENT_ID</code> in <code className="font-mono">/app/backend/.env</code> for analytics</li>
                    <li>◻ Switch <code className="font-mono">QIKINK_MODE=live</code> once Qikink issues live credentials</li>
                </ul>
            </div>
        </div>
    );
}
